<template>
    <b-card-code
        title="Edit User"
    >
          <!-- form -->
          <validation-observer
            ref="UserEditForm"
            #default="{invalid}"      
          >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="editUser"
          >
                <!-- Email -->
                <b-form-group
                  label="Email"
                  label-for="email">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="email"
                      rules="email|required">
                        <b-form-input
                          id="email"
                          v-model="email"
                          :state="errors.length > 0 ? false:null"
                          name="email"
                          disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <!-- Password -->
                <b-form-group
                  label="Password"
                  label-for="Password">
                    
                    <!-- <validation-provider
                      #default="{ errors }"
                      name="password"
                      rules="required"> -->
                        <b-input-group
                            class="input-group-merge"
                        >
                            <b-form-input
                            id="password"
                            v-model="password"
                            :type="passwordFieldType"
                            name="password"
                            placeholder="············"
                            />
                            <b-input-group-append is-text>
                                <feather-icon
                                    class="cursor-pointer"
                                    :icon="passwordToggleIcon"
                                    @click="togglePasswordVisibility"
                                />
                            </b-input-group-append>
                        </b-input-group>
                        
                    <!-- </validation-provider> -->
                </b-form-group>
                <!-- First Name -->
                <b-form-group
                  label="First Name"
                  label-for="first Name">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="first_name"
                      rules="required">
                        <b-form-input
                          id="first_name"
                          v-model="first_name"
                          :state="errors.length > 0 ? false:null"
                          name="first_name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <!-- First Name -->
                <b-form-group
                  label="Last Name"
                  label-for="Last Name">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="last_name"
                      rules="required">
                        <b-form-input
                          id="last_name"
                          v-model="last_name"
                          :state="errors.length > 0 ? false:null"
                          name="last_name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

               <b-form-group
                  v-if="is_staff_login"
                  label=""
                  label-for="Is staff">
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="is_staff"
                        name="is_staff"
                        value=true
                        unchecked-value=false
                        >
                        Is Staff (System User)?
                    </b-form-checkbox>
                </b-form-group>

                 <!-- Organization-->
                <b-form-group
                  label="Organization"
                  label-for="Organization" v-if="(is_staff ===false || is_staff ==='false' ) && is_staff_login">
                    <b-form-select  v-model="organization" :options="organizations"></b-form-select>
                </b-form-group>

               <!-- Organization-->
                <b-form-group
                  label="Role"
                  label-for="Role" v-if="is_staff === false || is_staff ==='false' ">
                    <b-form-select v-model="role" :options="roles"></b-form-select>
                </b-form-group>

                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="invalid"
                >
                  Save
                </b-button>
            </b-form>
          </validation-observer>

  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BForm, BButton,BFormTextarea, BInputGroupAppend,BInputGroup, BFormSelect, BFormCheckbox
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
// import { BTable } from 'bootstrap-vue'
// import { BPagination } from 'bootstrap-vue'

export default {
  components: {
    BCardCode,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BRow,
    BButton,
    BCol, 
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BInputGroup,
    BFormSelect,
    BFormCheckbox
  },
  data() {
    return {
      is_staff_login:this.$store.state.app.user.is_staff,
      email:"",
      password:"",
      first_name: "",
      last_name: "",
      is_staff: false,
      organization: "",
      role:"",
      organizations:[{ value: null, text: '--Select Organization--' }],
      roles:[{ value: null, text: '--Select Role--' }],
    }
  },
  created: function () {
     this.load();
  },
  methods: {

    load: function(){
        if(!this.is_staff_login)
          this.is_staff = false
        // Load oragnization drop down
        var self = this;
        if(this.is_staff_login){
          const o_options = {
                method: 'GET',
                headers: { 'content-type': 'application/json' },
                url: process.env.VUE_APP_BASEURL+'organization/organization/',
            }
            this.$http(o_options).then( ( res ) => {
              // console.log(res.data)
              res.data.map(function(value, key) {
                  let org = {
                      value: res.data[key].org_id, 
                      text: res.data[key].org_name
                      };
                  // console.log(res.data[key].profile.organization)
                  self.organizations.push(org)
              });
            })
        }

        // Load role dropdown
        const r_options = {
              method: 'GET',
              headers: { 'content-type': 'application/json' },
              url: process.env.VUE_APP_BASEURL+'user/groups/',
          }
          this.$http(r_options).then( ( res ) => {
            res.data.map(function(value, key) {
                let role = {
                    value: res.data[key], 
                    text: res.data[key].name
                    };
                // console.log(res.data[key].profile.organization)
                self.roles.push(role)
             });
            //  console.log("roles",self.roles)
          })

          // Load user details
        const options = {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
            url: process.env.VUE_APP_BASEURL+'user/users/'+this.$route.params.id,
          }
          this.$http(options).then( ( res ) => {
              console.log(res.data.groups)
              self.email = res.data.email
              self.first_name = res.data.first_name
              self.last_name = res.data.last_name
              self.is_staff = res.data.is_staff
              self.role = res.data.groups[0]
              if(res.data.profile.o_profile != null)
                self.organization = res.data.profile.o_profile.org_id
              // console.log("applied role",self.role)
            } )         
    },

    editUser: function() {
        this.$refs.UserEditForm.validate().then(success => {
        if (success) {
          //call to axios
            let data = {
                is_active:true,
                first_name:this.first_name,
                last_name:this.last_name,
                is_staff:this.is_staff
            }
            if(this.password){
                data['password'] = this.password
            }
            if(!this.is_staff_login)
                  this.organization = this.$store.state.app.user.profile.organization
            if((this.is_staff === false || this.is_staff ==='false') && this.organization){
                data['profile'] = {
                    organization:this.organization,
                    is_organization_owner:false
                }
            }
            if((this.is_staff === false || this.is_staff ==='false') && this.role){
                let groups_list =[]
                groups_list.push(this.role)
                data['groups'] = groups_list
            }
            console.log(data)
            const options = {
              method: 'PATCH',
              headers: { 'content-type': 'application/json' },
              data:data,
              url: process.env.VUE_APP_BASEURL+'user/users/'+this.$route.params.id+'/',
          }
          this.$http(options).then( ( res ) => {
            console.log(res)
            if(res.data.id){
               this.$router.push({name: 'Users'});
            }
          })
        }  
        })
      }
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  }
}
</script>